__turbopack_context__.v({
  "className": "kanit_8808998b-module__VhNPuG__className",
});
